import { useEffect, useRef } from 'react';
import type React from 'react';

export function useSyncRef<T>(value: T): React.RefObject<T> {
    const ref = useRef(value);
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref;
}
